/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TruncateMiddlePipe as ɵb} from './lib/pipes/truncate-middle.pipe';
export {TruncatePipe as ɵa} from './lib/pipes/truncate.pipe';